// routes/route-wrapper.tsx
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Routes from "./index";

const RoutesWrapper: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Handle navigation events from WebSocket notifications
    const handleNavigate = (event: CustomEvent) => {

      navigate(event.detail.to);
    };
    
    const handleNavigateToConv = (event: CustomEvent) => {

      navigate(`/chats`); // Navigate to chats page first
      // Small delay to ensure chats page is loaded, then focus on conversation
      setTimeout(() => {
        window.dispatchEvent(new CustomEvent('select-conversation', { 
          detail: event.detail || {}
        }));
      }, 100);
    };
    
    window.addEventListener('react-router-navigate' as any, handleNavigate);
    window.addEventListener('navigate-to-conversation' as any, handleNavigateToConv);
    
    return () => {
      window.removeEventListener('react-router-navigate' as any, handleNavigate);
      window.removeEventListener('navigate-to-conversation' as any, handleNavigateToConv);
    };
  }, [navigate]);

  return (
    <div>
      <Routes />
    </div>
  );
};

export default RoutesWrapper;
